<template>
  <div style="background-color: white">
    <el-row style="padding-top: 10px">
      <el-col :span="24">
        <el-button
          class="btn"
          size="small"
          type="primary"
          v-if="show.tj"
          @click="handleCreate"
          >添加变更</el-button
        >
        <el-form
          :inline="true"
          ref="deviceInfo"
          :model="deviceInfo"
          class="demo-form-inline"
          style="float: right !important"
        >
          <el-form-item label="项目">
            <el-select
              v-model="deviceInfo.item"
              filterable
              clearable
              style="width: 100%"
              placeholder="请选择项目"
            >
              <el-option
                v-for="item in idOptions"
                :key="item"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="部门">
            <el-cascader
              v-model="deviceInfo.laboratory"
              :options="options"
              :show-all-levels="false"
              :props="props"
              clearable
            ></el-cascader>
          </el-form-item>
          <el-form-item label="日期">
            <el-date-picker
              v-model="deviceInfo.date"
              value-format="yyyy-MM-dd"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="模糊查询">
            <el-input
              v-model="deviceInfo.content"
              auto-complete="off"
              placeholder="请输入搜索内容"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button size="small" type="primary" @click="findAllClick"
              >查询</el-button
            >
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table
          :header-cell-style="{ textAlign: 'center', background: '#eff3f6' }"
          :cell-style="{ textAlign: 'center' }"
          ref="multipleTable"
          :data="personalData"
          tooltip-effect="dark"
          style="width: 100%; text-align: center"
          stripe
        >
          <el-table-column
            :label="lable.index"
            type="index"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span>{{ scope.$index + (pageIndex - 1) * pagesize + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column
            sortable
            prop="glbh"
            label="管理编号"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column prop="zcmc" :label="lable.zcmc"> </el-table-column>
          <el-table-column prop="zcbh" :label="lable.zcbh"> </el-table-column>
          <el-table-column prop="companyName" label="使用单位">
          </el-table-column>
          <el-table-column
            sortable
            prop="personName"
            :label="lable.personName"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            sortable
            prop="originalName"
            :label="lable.ybgr"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="updateTime"
            :label="lable.updateTime"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            sortable
            prop="remark"
            label="备注"
            show-overflow-tooltip
          >
          </el-table-column>
        </el-table>
      </el-col>
      <!--分页工具条-->
      <el-col :span="24" class="toolbar" style="margin-top: 5px; height: 35px">
        <el-pagination
          v-if="personalData.length > 0"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pagesize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          style="float: right"
        >
        </el-pagination>
      </el-col>
    </el-row>

    <!----------------------------------------------------------------- 添加人员变更弹框-------------------------------------------------------------------------------------------------->
    <el-dialog
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="保管人变更"
      :before-close="resetting"
      style="width: 100% !important; margin-left: 100px"
    >
      <el-form
        :model="questionForm"
        ref="dataForm"
        label-position="right"
        label-width="100px"
        style="width: 90%; margin-left: 2.5%"
      >
        <el-row>
          <el-col :span="24">
            <el-form-item label="资产列表" prop="sccj">
              <el-table
                :header-cell-style="{
                  textAlign: 'center',
                  background: '#eff3f6',
                }"
                :cell-style="{ textAlign: 'center' }"
                ref="multipleTable"
                max-height="300"
                :data="questionForm.list"
                tooltip-effect="dark"
                style="width: 100%; text-align: center"
                stripe
              >
                <el-table-column
                  :label="lable.index"
                  type="index"
                  show-overflow-tooltip
                >
                </el-table-column>
                <el-table-column prop="glbh" label="管理编号">
                </el-table-column>
                <el-table-column prop="zcmc" :label="lable.zcmc">
                </el-table-column>
                <el-table-column prop="zcbh" :label="lable.zcbh">
                </el-table-column>
                <el-table-column
                  prop="bgr"
                  :label="lable.ybgr"
                  show-overflow-tooltip
                >
                </el-table-column>
                <el-table-column
                  prop="sccj"
                  label="生产厂家"
                  show-overflow-tooltip
                >
                </el-table-column>
                <el-table-column label="操作" show-overflow-tooltip>
                  <template slot="header" slot-scope="scope">
                    <DC :transferValue="transferValue"></DC>
                  </template>
                  <template slot-scope="scope">
                    <el-button
                      type="text"
                      @click="deleteClick(scope.row)"
                      size="small"
                      >删除</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="lable.updateTime" prop="updateTime">
              <el-date-picker
                v-model="questionForm.updateTime"
                style="width: 100%"
                value-format="yyyy-MM-dd"
                width="100%"
                type="date"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="lable.personName" prop="personName">
              <el-input
                :placeholder="'请输入' + lable.personName"
                v-model="questionForm.personName"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="备注" prop="remark">
              <el-input v-model="questionForm.remark" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          style="margin-left: 10px"
          size="small"
          type="success"
          @click="submitUpload"
          v-preventReClick
          >确认</el-button
        >
        <el-button @click="cancel">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
  
<script>
import {
  selectAllPersonal,
  insertPersonal,
  deletePersonal,
  findByUserIdCompanyTree,
  findByModule,
} from "../../api/api";
import MultipleDevices from "../../components/common/MultipleDevices.vue";

export default {
  name: "Custodian",
  components: {
    DC: MultipleDevices,
  },
  data() {
    return {
      show: {
        tj: false,
      },
      deviceInfo: {
        companyCode: "",
        date: "",
        content: "",
        item: "",
        laboratory: "",
      },
      lable: {},
      idOptions: [],
      props: {
        checkStrictly: true,
        label: "companyName",
        value: "companyCode",
        children: "zcompany",
        emitPath: false,
      },
      options: [],
      total: 0,
      pageIndex: 1,
      pagesize: 10,
      data: [],
      multipleTable: [],
      personalData: [],
      questionForm: {},
      dialogFormVisible: false,
    };
  },
  mounted() {
    this.findLable();
    this.findAll();
    this.getCompanyTree();
    var userinfo = JSON.parse(localStorage.getItem("user"));
    var arr = userinfo.role.menuId.split(",");
    arr.forEach((i) => {
      if (i == "76") {
        this.show.tj = true;
      }
    });
  },
  methods: {
    findAllClick() {
      this.pageIndex = 1;
      this.findAll();
    },
    resetting(done) {
      this.findAll();
      done();
    },
    getCompanyTree() {
      var userinfo = JSON.parse(localStorage.getItem("user"));
      var companyCode = "";
      if (
        userinfo.userRole == 1 ||
        (userinfo.fjqx != null &&
          (userinfo.fjqx.indexOf("3") != -1 ||
            userinfo.fjqx.indexOf("4") != -1))
      ) {
        companyCode = "-1";
      } else {
        companyCode = userinfo.companyCode;
      }
      findByUserIdCompanyTree(companyCode).then((datas) => {
        let { status, message, data } = datas;
        if (status == 200) {
          this.options = this.getTreeData(data);
        }
      });
    },
    getTreeData(data) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].zcompany.length < 1) {
          // 最后一级没有数据将children变成undefined
          data[i].zcompany = undefined;
        } else {
          // children不为空时继续调用该方法
          this.getTreeData(data[i].zcompany);
        }
      }
      return data;
    },
    //添加变更记录
    submitUpload() {
      var ids = [];
      for (var i = 0; i < this.questionForm.list.length; i++) {
        ids.push(this.questionForm.list[i].id);
      }
      var userinfo = JSON.parse(localStorage.getItem("user"));

      let permar = {
        ids: ids,
        personName: this.questionForm.personName,
        personalType: 2,
        remark: this.questionForm.remark,
        updateTime: this.questionForm.updateTime,
        userId: userinfo.userId,
      };
      insertPersonal(permar).then((datas) => {
        let { status, message } = datas;
        if (status == 400) {
          this.$message.error(message);
        } else if (status == 200) {
          this.dialogFormVisible = false;
          this.findAll();
          this.$message.success("添加成功");
        } else {
          this.$message.error("请求错误");
        }
      });
    },
    //删除信息
    deleteClick(row) {
      this.questionForm.list.splice(this.questionForm.list.indexOf(row), 1);
    },
    //关闭窗口
    cancel() {
      this.dialogFormVisible = false;
      this.findAll();
    },
    //选择资产
    transferValue(outData) {
      var list = [];
      for (var i = 0; i < outData.length; i++) {
        list.push(outData[i]);
      }
      this.$set(this.questionForm, `list`, list);
    },
    //添加变更
    handleCreate() {
      this.dialogFormVisible = true;
      this.questionForm = {};
      this.$set(
        this.questionForm,
        `updateTime`,
        this.timeUtil.timeFormat(new Date())
      );
    },
    //查找人员变更信息
    findAll() {
      var userinfo = JSON.parse(localStorage.getItem("user"));
      let map = {
        start: this.deviceInfo.date == null ? null : this.deviceInfo.date[0],
        end: this.deviceInfo.date == null ? null : this.deviceInfo.date[1],
        content: this.deviceInfo.content,
        companyCode: this.deviceInfo.laboratory,
        type: 2,
        userId: userinfo.userId,
      };
      selectAllPersonal(map).then((datas) => {
        let { status, message, data } = datas;
        if (status == 200) {
          if (data == null) {
            this.data = [];
          } else {
            this.data = data;
          }
          this.personalData = this.data.slice(
            (this.pageIndex - 1) * this.pagesize,
            this.pageIndex * this.pagesize
          );
          this.total = data.length;
        }
      });
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      //contentdata是所有的数据，是一个大数组。使用.slice()方法可以将大数组切分
      //.slice()方法接受两个参数，开始和结束的值
      //这样得到的currentdata就是固定只有10个值的数组了，就可以用v-for展示啦
      this.personalData = this.data.slice(
        (this.pageIndex - 1) * this.pagesize,
        this.pageIndex * this.pagesize
      );
    },
    handleSizeChange(val) {
      this.pagesize = val;
      this.personalData = this.data.slice(
        (this.pageIndex - 1) * this.pagesize,
        this.pageIndex * this.pagesize
      );
    },
    findLable() {
      findByModule("人员变更").then((datas) => {
        let { status, message, data } = datas;
        if (status == 200) {
          this.lable = data;
        }
      });
    },
  },
};
</script>
<style >
.el-checkbox__inner {
  border: 1px solid #606266 !important;
}
</style>
<style scoped>
.el-input {
  width: 100%;
}

.btn {
  float: left;
  margin-left: 5px;
}
</style>
  


// WEBPACK FOOTER //
// src/views/personnelChange/Custodian.vue